import { useMemo } from "react";

import { useCurrentUser } from "@/core/hooks/use-current-user";

type Organization = NonNullable<
  ReturnType<typeof useCurrentUser>
>["organization"];

interface UseCurrentOrganizationResult<T extends boolean> {
  organization: T extends true
    ? NonNullable<Organization>
    : Organization | undefined;
  organizationId: T extends true ? string : string | undefined;
}

export function useCurrentOrganization<T extends boolean = false>({
  throw: shouldThrow = false as T,
}: { throw?: T } = {}): UseCurrentOrganizationResult<T> {
  const user = useCurrentUser();
  const organization = useMemo(() => user.organization, [user]);
  const organizationId = useMemo(() => organization?.id, [organization]);

  if (shouldThrow && !organizationId) {
    throw new Error("Organization not found");
  }

  return { organization, organizationId } as UseCurrentOrganizationResult<T>;
}
